import * as actions from '@actions';
import { useSuspenseQuery, UseSuspenseQueryOptions } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

export default function useUserAppointments(
  type: Parameters<typeof actions.getUserAppointment>[0] = 'USER_APPOINTMENTS',
  request: Parameters<typeof actions.getUserAppointment>[1],
  options = {} satisfies Partial<UseSuspenseQueryOptions>
) {
  const dispatch = useDispatch();
  const invalidInput = 'appt_id' in request && !Number.isFinite(Number(request.appt_id));

  const getUserAppointments = () => {
    if (invalidInput) {
      return null;
    }

    return dispatch(actions.getUserAppointment(type, request));
  };

  const { data, refetch, isLoading } = useSuspenseQuery({
    queryKey: ['userAppointment', type, request],
    queryFn: getUserAppointments,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...options
  });
  return {
    userAppointments: data,
    refetchUserAppointments: refetch,
    isLoadingUserAppointments: isLoading
  };
}
